const Pattern = {
  ORG_ID: /^[0-9a-z]{24}$/,
  MOBILE: /^1[0-9]{10}$/,
  EMAIL: /^([A-Za-z0-9_\-])+@([A-Za-z0-9_\-])+\.([A-Za-z]{2,4})$/,
  ORG_PREFIX: /org\/([^\/]*)(\/|$)/,
  ID_CARD: /^(?:[0-9xX]{18}|[HMhm](?:\d{8}|\d{10})|\d{8}|\d{10})$/,
};
export default Pattern;
